import React from 'react';

const DEFAULT_HOSTNAME = 'http://example-test.site';

export interface BreadcrumbsContextModel {
  hostname: string;
}

export const BreadcrumbsContext = React.createContext<BreadcrumbsContextModel>({
  hostname: DEFAULT_HOSTNAME,
});
